const PRIMARY_COLOR = 'linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%)';
const WHITE = '#F4F4F4';
const WHITE_0 = '#FFFFFF';
const BTN_COLOR = "linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%)"

const lightTheme = {
    primaryColor: PRIMARY_COLOR,
    backgroundColor: WHITE,
    appbarColor: PRIMARY_COLOR,
    navbarColor: WHITE_0,
    buttonColor: BTN_COLOR,
    buttonHoverColor: BTN_COLOR,
}

export default lightTheme;